<template>
	<div>
		<template v-if="headerShow">
			<!-- 横向滚动swiper -->
			<div class="swiper-canpin">
				<div class="swiper-wrapper">
					<div class="swiper-slide" v-for="(item,index) in list" :key="index" @click="goDetail(item,index)">
						<div class="swiper-slide-box">
							<div class="swiper-slide-img">
								<img :src="item.cover" />
							</div>
							<div class="swiper-slide-wz">
								{{item.type_name}}
							</div>
						</div>
					</div>
				</div>
			</div>
		</template>
		<template v-else>
			<el-row :gutter="10">
				<el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="8">
					<div class="swiper-slide" v-for="(item,index) in list" :key="index" @click="goDetail(item,index)">
						<div class="swiper-slide-box">
							<div class="swiper-slide-img">
								<img :src="item.cover" />
							</div>
							<div class="swiper-slide-wz">
								{{item.type_name}}
							</div>
						</div>
					</div>
				</el-col>
			</el-row>
		</template>
	</div>
</template>

<script>
	export default {
		components: {

		},
		props: {
			list: {
				typeof: Array,
				default: []
			}
		},
		data() {
			return {

			}
		},
		mounted() {
			if (this.headerShow) {
				const mySwiper = new this.$swiper('.swiper-canpin', {
					// 方向
					direction: 'horizontal',
					slidesPerView: 'auto', // 每屏显示3个滑块
					spaceBetween: 30,
					freeMode: false,
					autoplay: false,
					// 自动播放
					// autoplay: {
					// 	delay: 3000,
					// 	disableOnInteraction: false,
					// },
				});
			} else {
				const mySwiper = new this.$swiper('.swiper-canpin', {
					// 方向
					direction: 'horizontal',
					// freeMode: false,
					autoplay: false,
					// 自动播放
					// autoplay: {
					// 	delay: 3000,
					// 	disableOnInteraction: false,
					// },
				});
			}

		},
		methods: {
			goDetail(e, a) {
				let t = this;
				let value = ['njxt', 'dznj', 'zbcp']
				t.$router.push({
					push: '/product',
					name: 'product',
					query: {
						value: value[a]
					}
				})
			}
		}
	}
</script>

<style>

</style>
<style scoped lang="scss">
	.swiper-slide:hover {
		.swiper-slide-box {
			// box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
		}

		.swiper-slide-img {
			img {
				transform: scale(1.1);
			}
		}

	}

	.swiper-slide {
		margin-left: 10px;
		width: 375px;
		height: 500px;
		padding: 30px 0;
		margin-right: 20px;
		box-sizing: border-box;
		cursor: pointer;

		.swiper-slide-box {
			background-color: #fcfcfc;
			// border-radius: 20px;
			transition: all 0.3s ease-in-out;
		}

		.swiper-slide-img {
			width: 100%;
			height: 340px;
			overflow: hidden;

			img {
				width: 100%;
				height: 340px;
				object-fit: cover;
				transform: scale(1);
				transition: all 0.3s ease-in-out;
			}
		}

		.swiper-slide-wz {
			height: 100px;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 24px;
			font-family: Source Han Sans CN;
			font-weight: 400;
			color: #000000;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}
	}

	@media screen and (max-width:1200px) {
		
		.swiper-slide {
			// max-width: 100vw;
			width: 100vw !important;
			margin-right:0px !important;
			margin-left:0px !important;
			margin-bottom: 20px;
			padding: 0 !important;
			height: auto !important;
			.swiper-slide-wz{
				font-size: 16px !important;
			}
		}

	}
</style>